import { render, staticRenderFns } from "./academyCategories.vue?vue&type=template&id=6d15cc16&"
import script from "./academyCategories.vue?vue&type=script&lang=js&"
export * from "./academyCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports